import { MutationTree } from "vuex";
import { AuthMutationsTypes, AuthStateType } from "./interface";
import { MutationTypes } from "./mutations-types";

export const mutations: MutationTree<AuthStateType> & AuthMutationsTypes = {
  [MutationTypes.IS_LOGGED_IN](state, payload: boolean) {
    state.isLoggedIn = payload;
  },
  [MutationTypes.CHANGE_VIEW_TYPE](state, payload: string) {
    state.view = payload;
  }
};
